module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// C:/TeamCity/BuildAgent_2/work/861f9e7e0cb825c7/node_modules/core-js/modules/_fails.js
// module id = umMR
// module chunks = 15